angular.module 'zc.commonApi'
.factory 'ZcsAgencyInvoice', ($q, FacadeV2) ->
  class ZcsAgencyInvoice
    @all: (agency_id) ->
      FacadeV2.request "/agencies/#{agency_id}/zcs_agency_invoices/"
      .then (res) ->
        # for some reason, the invoice_price etc are as strings
        _.map(res.data, (d) ->
          d.invoice_price = parseInt(d.invoice_price)
          d.invoice_price_tax_excluded = parseInt(d.invoice_price_tax_excluded)
          d
        )

    @find: (agency_id, month) ->
      FacadeV2.request "/agencies/#{agency_id}/zcs_agency_invoices/#{month}", {}
      .then (res) ->
        # for some reason, the invoice_price etc are as strings
        res.data.invoice_price = parseInt(res.data.invoice_price)
        res.data.invoice_price_tax_excluded = parseInt(res.data.invoice_price_tax_excluded)
        res.data

    @findAgencyApikeyMaxInvoice: (agency_id, month) ->
      FacadeV2.request "/agencies/#{agency_id}/zcs_agency_invoices/#{month}/apikeyMaxInvoice", {}
      .then (res) ->
        # convert array of objects to flat object
        max_invoice_by_apikey = {}
        _.each(res.data, (d) ->
          max_invoice_by_apikey[d.apikey] = d.max_invoice
        )
        max_invoice_by_apikey



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/facade/zcs_agency_invoice.service.coffee